import { render, staticRenderFns } from "./ModelViewer.vue?vue&type=template&id=e79d46f4&scoped=true"
import script from "./ModelViewer.vue?vue&type=script&lang=js"
export * from "./ModelViewer.vue?vue&type=script&lang=js"
import style0 from "./ModelViewer.vue?vue&type=style&index=0&id=e79d46f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e79d46f4",
  null
  
)

export default component.exports